import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

type BronzeSubscriptionFormBlockState = {
    submitting: boolean;
};

const initialState: BronzeSubscriptionFormBlockState = {
    submitting: false
};

export const BronzeSubscriptionFormBlockStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setSubmitting(submitting: boolean) {
            patchState(store, { submitting });
        }
    }))
);
